/* eslint-disable no-unused-vars */
import { useId } from 'react';
import * as S from './NotificationModal.styled';
import { Buttons, ModalBase, Separators } from 'components';

export const iconTypes = {
  info: 'info',
  warning: 'warning',
  error: 'error',
  question: 'question',
};

export const NotificationModal = ({
  id,
  children,
  onCancel,
  iconType,
  iconSign,
  title,
  onConfirm,
  cancelBtnText,
  confirmBtnText,
  cancelBtnType,
  confirmBtnType,
}) => {
  const closeBtnId = useId();
  const confirmBtnId = useId();

  const CancelBtnComponent = Buttons[cancelBtnType];
  const ConfirmBtnComponent = Buttons[confirmBtnType];

  return (
    <ModalBase>
      <S.Container>
        <S.TextBlock>
          {title && <S.ModalDeleteTitle>{title}</S.ModalDeleteTitle>}
          <S.ModalDeleteText>{children}</S.ModalDeleteText>
        </S.TextBlock>
        <S.NotificationIcon type={iconType}>{iconSign}</S.NotificationIcon>
      </S.Container>
      <Separators type={Separators.separatorTypes.small} />
      <S.Footer>
        {cancelBtnType && (
          <>
            <CancelBtnComponent style={{ width: '100%' }} id={closeBtnId} onClick={onCancel}>
              {cancelBtnText}
            </CancelBtnComponent>
          </>
        )}
        {confirmBtnType && (
          <>
            <ConfirmBtnComponent
              style={{ width: '100%' }}
              id={confirmBtnId}
              onClick={() => onConfirm(id)}
            >
              {confirmBtnText}
            </ConfirmBtnComponent>
          </>
        )}
      </S.Footer>
    </ModalBase>
  );
};

NotificationModal.iconTypes = { ...iconTypes };
NotificationModal.btnTypes = { ...Buttons.buttonTypes };
